import Plausible from './lib/tracker';
export type { PlausibleOptions } from './lib/tracker';
export type { EventOptions } from './lib/request';

export default Plausible;
